// @flow

import React, { Component } from "react";
import { localize } from "redux-i18n";
import classNames from "classnames";
import type { WidgetProps } from "@rjsf/utils";
import { ToggleButton, View } from "@components";

type Props = $Exact<{
  ...WidgetProps,
  options: Object,
}>;

class ToggleWidget extends Component<Props> {
  get items() {
    return (this.props.options.labels || this.props.options.enumOptions).map((item: Object) => {
      return {
        active: this.value === item.value,
        label: item.label,
        value: item.value,
      };
    });
  }
  get value() {
    return this.props.value;
  }
  get label() {
    return (
      (this.props.options.labels || this.props.options.enumOptions).find(
        (item: Object) => item.value === this.value,
      )?.label || this.props.t("N/A")
    );
  }
  get showAsBadge() {
    return !!this.props.options.statusBadge;
  }

  render() {
    if (this.props.readonly) {
      return (
        <View name="ToggleWidget" direction="row" alignItems="center" flex="1">
          <span
            className={classNames("fs-14", {
              "gs-badge": this.showAsBadge,
              "background-color-mint": this.value && this.showAsBadge,
              "background-color-berry":
                (!this.value || this.value === "INACTIVE") && this.showAsBadge,
            })}
          >
            {this.showAsBadge ? (
              this.props.t(this.label.toUpperCase())
            ) : (
              <input
                className="form-control no-border"
                type="text"
                readOnly
                value={this.props.t(this.label.toUpperCase())}
              />
            )}
          </span>
        </View>
      );
    } else {
      return (
        <ToggleButton
          initialValue={this.props.value}
          items={this.items}
          onChange={this.props.onChange}
          disabled={this.props.disabled}
          readonly={this.props.readonly}
        />
      );
    }
  }
}

export default localize()(ToggleWidget);
